const length = (v: string, wantedLength: number) => {
  if (v.toString().length !== wantedLength) {
    return `Value length must be equal to ${wantedLength} characters`
  }
  return undefined
}

const maxLength = (v: string, wantedMaxLength: number) => {
  if (v.toString().length > wantedMaxLength) {
    return `Value length must be less or equal to ${wantedMaxLength} characters`
  }
  return undefined
}

export const string = {
  length: (wantedLength: number) => (v: string) => length(v, wantedLength),
  maxLength: (wantedMaxLength: number) => (v: string) => maxLength(v, wantedMaxLength)
}
